import Vue from 'vue';
import Router from 'vue-router';
import Cart from '@/pages/Cart';
import ServiceDetail from '@/pages/ServiceDetail';
import Categories from '@/pages/Categories';
import CategoriesList from '@/pages/CategoriesList';
import CartDate from '@/pages/CartDate';
import CustAppoint from '@/pages/CustAppoint';
import StoreAppoint from '@/pages/StoreAppoint';
import MyAccount from '@/pages/MyAccount';
import MyAccountSend from '@/pages/MyAccountSend';
import CartConfirm from '@/pages/CartConfirm';
import CartResDone from '@/pages/CartReservationDone';
import Startup from '@/pages/Startup';
import ErrorLoading from  '@/pages/ErrorLoading';
import StoreClosed from '@/pages/StoreClosed';
import PaymentStatus from '@/pages/PaymentStatus';


import SalonSelect from '@/pages/SingleSalon/SalonSelect';
import SalonCategories from '@/pages/SingleSalon/SalonCategories';

Vue.use(Router);
//mode: 'history',

export default new Router({
  
  routes: [
    {
      path: '/',
      name: 'Startup',
      component: Startup,
    }, {
      path: '/error',
      name: 'Errror',
      component: ErrorLoading,
    }, 
    {
      path: '/listws',
      name: 'ListWs',
      component: Categories,
    }, {
      path: '/list',
      name: 'List',
      component: CategoriesList,
    }, {
      path: '/cart',
      name: 'Cart',
      component: Cart,
    },{
      path: '/confirm',
      name: 'Confirm',
      component: CartConfirm,
    },
    {
      path: '/salonselect',
      name: 'SalonSelect',
      component: SalonSelect,
    },
    {
      path: '/saloncategories',
      name: 'SalonCategories',
      component: SalonCategories,
    },
    {
      path: '/myaccount',
      name: 'MyAccount',
      component: MyAccount,
    },
    {
      path: '/myaccountsend',
      name: 'MyAccountSend',
      component: MyAccountSend,
    },
    {
      path: '/confirmed',
      name: 'ReservationDone',
      component: CartResDone,
    },
    {
      path: '/servicedetail/:id',
      name: 'ServiceDetail',
      component: ServiceDetail
    },
    ,{
      path: '/category/:id',
      name: 'Category',
      component: Categories
    },
    {
      path: '/dateappoint',
      name: 'DateAppoint',
      component: CartDate
    },
    {
      path: '/custappoint/:id',
      name: 'CustAppoint',
      component: CustAppoint
    },
    {
      path: '/storeappoint/:id',
      name: 'StoreAppoint',
      component: StoreAppoint
    },
    {
      path: '/paymentstatus/:id',
      name: 'PaymentStatus',
      component: PaymentStatus
    },
    {
      path: '/storeclosed',
      name: 'StoreClosed',
      component: StoreClosed
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js